import React, { Component } from "react";
import "antd/dist/antd.css";
import { Layout, Row, Col } from "antd";
import { Route, Switch, withRouter } from "react-router-dom";
// import Header from '../Components/Admin/AdminHeader';
import Header from "../Components/header";
import Sidemenu from "../Components/Sidemenu";
import "../Stylesheet/carrier.scss";
import AppRoutes from "../Config/AppRoutes";
import { withAppContext } from "../store/contextStore";
import newLogo from "../Images/newLogo.JPG";
import DriverHeader from "./driver/DriverHeader";
import DriverFooter from "./driver/DriverFooter";

const { Content, Sider } = Layout;

class Application extends Component {
  render() {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    // const { userDetails } = this.props.context.state;
    // const { user } = this.props.context.state;
    return (
      <div
        style={{
          backgroundColor: "#F2F3F6",
          minHeight: "100vh",
        }}
      >
        <Layout className="layout" style={{ minHeight: "100vh" }}>
          {/* {userDetails && userDetails.userProfile === "D" && <DriverHeader />} */}
          {userDetails && userDetails.userProfile === "S" ? (
            <Row>
              <Col xs={0} sm={0} md={24} lg={24}>
                <Sider width={200}>
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "40px",
                      marginBottom: "10px",
                    }}
                  >
                    <img
                      src={newLogo}
                      className="leads-name"
                      alt="Bulk material pro-img"
                      style={{ width: "76%" }}
                    />
                    <br />
                    {/* <span style={{ color: "#FFFFFF" }}>Bulk Material Pro </span> */}
                  </div>
                  <Sidemenu />
                </Sider>
              </Col>
            </Row>
          ) : (
            <Header />
          )}
          <Content>
            <Switch>
              {AppRoutes.map((route) => (
                <Route
                  exact={route.exact}
                  path={route.path}
                  component={route.component}
                  key={route.key}
                />
              ))}
            </Switch>
          </Content>
        </Layout>
        {userDetails && userDetails.userProfile === "D" && (
          <div className="show-on-mobile">
            <div style={{ minHeight: "90px" }}></div>
            <DriverFooter />
          </div>
        )}
      </div>
    );
  }
}
export default withAppContext(withRouter(Application));
